<template>
  <span
    :class="{ availabilityLabel: true, lastTickets: isLastTickets }"
  >
    ({{ availability }})
  </span>
</template>

<script>
  export default {
    name: 'AvailabilityLabel',
    props: {
      availability: {
        type: Number,
        required: true,
      },
      lastTicketsMaxQty: {
        type: Number,
        required: true,
      },
    },
    computed: {
      isLastTickets() {
        return parseInt(this.availability, 10) <= this.lastTicketsMaxQty;
      },
    },
  };
</script>

<style scoped lang="stylus">
  .availabilityLabel
    font-size: .6em
    color: #888
    &.lastTickets
      color: #f00
</style>
